import { RxHR } from '@akanass/rx-http-request';

export abstract class QronoPortService {
	protected api = RxHR.defaults({
		baseUrl: process.env.REACT_APP_QRONOPORT_API_BASE_URL,
		json: true,
	});
}
